import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  CustomInput,
  Form,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row } from 'reactstrap';

class DeclinedOfferAFF extends Component {
  state = {
    modal: false,
    agreeChecked: false
  }

  handleModal = (e) => {
    e.preventDefault();
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }

  handleCheck = () => {
    this.setState({ agreeChecked: !this.state.agreeChecked });
  }

  handleCheckBtn = () => {
    this.setState({
      agreeChecked: true,
      modal: false
    });
    window.scrollTo(0,document.body.scrollHeight);
  }

  render() {
    const { modal, agreeChecked } = this.state;

    return (
      <div className="page-aff">
        <Container>

          <Row className="mb-3 mt-4">
            <Col xs={12} md={9} lg={5} className="text-center ml-auto mr-auto">
              <h3 className="ml-auto mr-auto mb-2">Unfortunately, you are not approved for a loan at this time.</h3>
              <p className="mb-2">An adverse action notice will be sent within 30 days.</p>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={9} lg={5} className="text-center ml-auto mr-auto">
              <h2 className="mb-4 cta-arrows"><u>But wait!</u> You might still qualify:</h2>
              <Card color="primary">
                <Form>
                  <CardBody>
                    <h4 className="mb-3 mt-1 text-white">We have teamed up with one of our lending partners, American First Finance* who may still be able to offer you a loan.</h4>
                    <p className="mb-3 mt-1 text-white">Find out if you are approved in a few simple steps!</p>
                    <img src="/images/aff-logo.svg" alt="American First Finance" width="94%" className="mb-3" />
                    <FormGroup className="mb-3">
                      <CustomInput type="checkbox" id="disclosuresCheckbox" label="I've read and agree to" className="mr-0 text-white" inline checked={agreeChecked} readOnly />
                      <a href="/" onClick={this.handleModal} className="text-white">&nbsp;<u>AFF’s Disclosures</u></a>
                    </FormGroup>
                    <Button tag={Link} to="/" color="secondary" className="w-100" disabled={!agreeChecked}>Yes, Continue</Button>
                  </CardBody>
                </Form>
              </Card>
            </Col>
          </Row>

        </Container>

        <Modal isOpen={modal} toggle={this.handleModal} size="lg" className="modal-aff">
          <ModalHeader toggle={this.handleModal}>American First Finance Financial Disclosure</ModalHeader>
          <ModalBody>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean mollis nunc at risus imperdiet, non iaculis urna tempus. Curabitur sed euismod felis. Nullam urna tortor, feugiat at volutpat ut, rutrum nec lacus. Nam ut dignissim quam. Nam ultricies massa nunc, sit amet mollis lacus molestie in. Quisque vestibulum justo nec elit pharetra, id imperdiet lacus ornare. Quisque quis placerat orci, a scelerisque enim. Pellentesque eleifend vel dolor a ornare. In in porttitor ipsum. Integer tristique nibh eget ante hendrerit, quis euismod mi volutpat. Quisque accumsan lobortis augue et accumsan.</p>
            <p>Curabitur interdum nisi non turpis pretium pellentesque. Maecenas nec sem elementum, laoreet leo sed, pellentesque libero. Fusce ante ante, varius sed odio vel, pulvinar porttitor nisi. Nunc est neque, maximus id ligula ut, tempus finibus nisi. Sed dolor nulla, faucibus quis dictum sit amet, malesuada et ex. Praesent tristique lacus non justo blandit, ac lobortis elit efficitur. Praesent quis elit a massa aliquet venenatis ut suscipit felis.</p>
            <p>Etiam at nisi et nulla ultrices varius. Pellentesque semper, sapien tincidunt finibus vulputate, lectus justo placerat odio, a vestibulum turpis tellus in quam. Sed ac rhoncus lectus. Vivamus sem est, fermentum eu magna at, elementum ultricies enim. Phasellus vitae diam nec libero efficitur suscipit. Vestibulum vulputate in purus nec feugiat. Maecenas convallis nisi sed arcu ultrices rutrum. Integer eget porta urna. Integer nec velit in magna faucibus placerat. Nulla bibendum consectetur odio, ut eleifend sapien semper non. Ut suscipit tempus nunc, vitae tristique massa porta in. Phasellus vel diam condimentum, gravida enim id, feugiat tortor. Donec at sapien diam. Nullam non tincidunt magna, a pellentesque neque.</p>
          </ModalBody>
          <ModalFooter>
            <Button color="aff" onClick={this.handleCheckBtn} className="ml-auto mr-auto">I Understand &amp; Agree</Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default DeclinedOfferAFF;
